import { render, staticRenderFns } from "./97.vue?vue&type=template&id=037e2fff&scoped=true&"
var script = {}
import style0 from "./97.vue?vue&type=style&index=0&id=037e2fff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037e2fff",
  null
  
)

export default component.exports